const TYPE = 'REGISTRATION_SET_FATAL';

const action = (fatal) => (dispatch) => dispatch({ type: TYPE, payload: fatal });

export default { action, TYPE };
